export const REQUEST_SHOW_LOADER = 'global/REQUEST_SHOW_LOADER';
export const REQUEST_HIDE_LOADER = 'global/REQUEST_HIDE_LOADER';

export const RECEIVED_ALL_NOTIFICATION = "notification/RECEIVED_ALL_NOTIFICATION";

export const CREATE_EDIT_CONFIGURATION = "config/CREATE_EDIT_CONFIGURATION";